import { useContext } from "react";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { ConfigsProvider, ConfigContext } from "react-builder";
import { LevelsElearnProvider, useLanguage, useLevelsData } from "../../providers/ElearningV2";

@AttributeGroup({
  title: "LevelsBuilderV2",
  blockName: "LevelsBuilderV2",
  module: "elearning",
  icon: "query",
})
export class LevelsBuilderAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  levelId?: string;
}

function LevelsBuilder(props: ComponentProps<LevelsBuilderAttributes>) {
  const { watchedLevels } = useLevelsData();
  const content = useContext(ConfigContext);
  const userLanguage = useLanguage();
  const levelIdFilter = props.attributes.levelId
    ? content.getContent(props.attributes.levelId)
    : "";

  const isWatched = (levelId: string) => {
    if (!watchedLevels || !watchedLevels.length) return false;
    return !!watchedLevels.find((l) => l == levelId);
  };

  return (
    <LevelsElearnProvider loader={<></>}>
      {(levels) => {
        return (
          <ConfigsProvider
            configJson={{
              levels: levels
                ?.filter((l) => !levelIdFilter || l._id == levelIdFilter)
                .map((l) => {
                  const translationKey = l.translations[userLanguage] ? userLanguage : "EN";
                  return {
                    ...l,
                    isWatched: isWatched(l._id),
                    tagList: (l.translations[translationKey]?.translatedTags ?? "").split(","),
                    content: { ...l.translations[translationKey] },
                    description: l.translations[translationKey].translatedDescription,
                    chapterCount: l.chapters.length,
                    coverMobileUrl: l.coverMobile.url,
                    coverUrl: l.cover.url,
                    id: l._id,
                    name: l.translations[translationKey].translatedName,
                    thumbMobileUrl: l.thumbMobile.url,
                    thumbUrl: l.thumb.url,
                    title: l.translations[translationKey].translatedName,
                  };
                }),
            }}
          >
            <>{props.children}</>
          </ConfigsProvider>
        );
      }}
    </LevelsElearnProvider>
  );
}

LevelsBuilder.prototype.Props = LevelsBuilderAttributes;

export default LevelsBuilder;
